import _ from 'underscore';
import React, { useContext, useEffect } from 'react';
import { generateGuid } from '@bingads-webui-universal/primitive-utilities';
import { InstrumentationContext } from '@bingads-webui-react/hoc-with-instrumentation';


const activityFactory = _.memoize((instrumentation) => {
  const schema = {
    scenario: [
      {
        name: 'ReportsV4Telemetry',
        value: 'ReportsV4Telemetry',
        activity: [
          { name: 'CtrLogger', value: 'CtrLogger' },
        ],
      },
    ],
  };

  instrumentation.addScenario(schema);

  const scenario = instrumentation.ReportsV4Telemetry.create();
  const activity = scenario.CtrLogger.create();

  return activity;
});

// !!! Important: do not reorder the arguments, _.memorize takes the first argument as cache key
function ctrLoggerFactoryImpl(componentName, instrumentation) {
  if (!instrumentation) {
    throw new Error('instrumentation is not specified!');
  }

  if (!componentName) {
    throw new Error('componentName is not specified!');
  }

  const activity = activityFactory(instrumentation);

  let impressionId;

  function impressionStart() {
    if (!impressionId) {
      impressionId = generateGuid();

      activity.trace({
        componentName,
        event: 'ImpressionStart',
        impressionId,
      });
    }
  }

  function impressionFinish() {
    if (impressionId) {
      activity.trace({
        componentName,
        event: 'ImpressionFinish',
        impressionId,
      });

      impressionId = undefined;
    }
  }

  function click({ target, extraData, parentTarget }) {
    if (impressionId) {
      activity.trace({
        componentName,
        event: 'Click',
        target,
        extraData,
        impressionId,
        parentTarget,
      });
    }
  }

  return {
    impressionStart,
    impressionFinish,
    click,
  };
}

export const ctrLoggerFactory = _.memoize(ctrLoggerFactoryImpl);


export function useCtrLogger(componentName, autoStart = true) {
  const instrumentation = useContext(InstrumentationContext);
  const ctrLogger = ctrLoggerFactory(componentName, instrumentation);

  useEffect(() => {
    if (autoStart) {
      ctrLogger.impressionStart();

      return function cleanup() {
        ctrLogger.impressionFinish();
      };
    }

    return undefined;
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return ctrLogger;
}


export function withCtrLogger(Comp, componentName, autoStart = true) {
  return function CompWithCtrLogger(props) {
    const ctrLogger = useCtrLogger(componentName, autoStart);

    return <Comp {...props} ctrLogger={ctrLogger} />;
  };
}
